/* eslint-disable camelcase */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async step1(
      _,
      {
        company_type_id,
        company_type_code,
        commitment,
        name,
        register_type,
        global_activity_area,
        state,
        digital_setup_option,
        entity_name,
      }
    ) {
      return window.$axios.post('register/company-type', {
        company_type_code,
        company_type_id,
        commitment,
        name,
        country_id: 1,
        register_type,
        global_activity_area,
        state,
        digital_setup_option,
        entity_name,
      });
    },
    async createCompany(_, { company_nation_id }) {
      /* return window.$axios.post('tenant/company/create', {
        company_nation_id,
      }); */
      return window.$axios.post('/tenant/company/create', {
        company_nation_id,
      });
    },
    async package(_, { packages, productType, skipStep, skipStepUrl, companyNationId }) {
      let uniquePackages = [];
      if (companyNationId === 1) {
        if (packages.length > 0) {
          packages.forEach(function (index) {
            if (!uniquePackages.includes(index)) {
              uniquePackages.push(index);
            }
          });
        }
      } else {
        uniquePackages = packages;
      }

      let url = 'register/package';
      if (skipStepUrl) {
        url += '?skipStep';
      }

      return window.$axios.post(url, {
        package: uniquePackages,
        productType: productType,
        skipStep: skipStep,
      });
    },
  },
});
